import { render, staticRenderFns } from "./parent-view-toolbar.vue?vue&type=template&id=96c1f03e&"
import script from "./parent-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./parent-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports